import Foreign, { ForeignSections } from './Foreign';

export default Foreign;
export { ForeignSections };
